import script from "./InstructionVoipTimePage.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionVoipTimePage.vue?vue&type=script&setup=true&lang=js"

import "./InstructionVoipTimePage.vue?vue&type=style&index=0&id=63cc9812&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63cc9812"]])

export default __exports__